__turbopack_context__.v({
  "current": "account-button-module-scss-module__0wWTiW__current",
});
